const stores = new Map<string, any>();

export function getAsyncLocalStorage<T>(
	name: string,
): { getStore(): T | undefined; run<R>(store: T, cb: () => R): R } | null {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (!process.env.REACT_SSR) {
		return null;
	}

	const AsyncLocalStorage = (globalThis as any)?.__vm_internals__?.asyncLocalStorage
		?.AsyncLocalStorage;

	if (!AsyncLocalStorage) {
		return null;
	}

	let store = stores.get(name);
	if (!store) {
		store = new AsyncLocalStorage();
		stores.set(name, store);
	}
	return store;
}
